<template>
    <v-card>
        <v-card-title>
            {{$t('event_agenda.items')}}
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initAddAgendaItem">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers"
                      :items="tableAgendas"
                      :loading="isAgendaItemPending"
                      @pagination="currentPagination"
                      disable-sort>
            <template v-slot:item.scroller="{value}">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.date_string="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('date_string')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                :label="$t('agenda_item.date_string')"
                                :placeholder="$t('agenda_item.date_string')"
                                v-model="inlineEditingAgendaItemList[item.id].date_string"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('date_string'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('date_string'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.agenda_item_key="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('agenda_item_key')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">{{value}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-text-field outlined hide-details
                                    :label="$t('agenda_item.agenda_item_key')"
                                    :placeholder="$t('agenda_item.agenda_item_key')"
                                    v-model="inlineEditingAgendaItemList[item.id].agenda_item_key"></v-text-field>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('agenda_item_key'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('agenda_item_key'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">{{value}}</div>
            </template>
            <template v-slot:item.html_desc="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('html_desc')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">
                            <froalaView v-model="value" class="popup-preview"></froalaView>
                        </div>
                    </template>
                    <v-card>
                        <v-card-title>
                            {{$t('agenda_item.html_desc')}}
                        </v-card-title>
                        <v-card-text>
                            <v-container class="popup-editor-container">
                                <froala
                                    v-if="showEditor"
                                    :config="froalaConfig"
                                    v-model="inlineEditingAgendaItemList[item.id].html_desc"
                                ></froala>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('html_desc'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('html_desc'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">
                    <froalaView v-model="value" class="popup-preview"></froalaView>
                </div>
            </template>
            <template v-slot:item.html_content="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('html_content')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">
                            <froalaView v-model="value" class="popup-preview"></froalaView>
                        </div>
                    </template>
                    <v-card>
                        <v-card-title>
                            {{$t('agenda_item.html_content')}}
                        </v-card-title>
                        <v-card-text>
                            <v-container class="popup-editor-container">
                                <froala
                                    v-if="showEditor"
                                    :config="froalaConfig"
                                    v-model="inlineEditingAgendaItemList[item.id].html_content"
                                ></froala>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn color="secondary" @click="cancelInline(item, item.id.concat('html_content'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="saveInlineItem(item, item.id.concat('html_content'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode">
                    <froalaView v-model="value" class="popup-preview"></froalaView>
                </div>
            </template>
            <template v-slot:item.live="{value,item}">
                <v-menu
                    v-if="!isEditOrderMode"
                    :ref="item.id.concat('live')"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-right="10"
                    transition="scale-transition"
                    >
                    <template v-slot:activator="{ on }">
                        <div @click="openInline(item)" v-on="on" style="cursor: pointer;">
                            <span v-if="value" class="red white--text pa-1 rounded"><b>Live</b></span>
                            <span v-else class="grey lighten-2 white--text pa-1 rounded"><b>Live</b></span>
                        </div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <v-checkbox
                                :label="$t('agenda_item.live')"
                                v-model="inlineEditingAgendaItemList[item.id].live"
                                ></v-checkbox>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn class="mr-3" color="secondary" @click="cancelInline(item, item.id.concat('live'))">{{$t('cancel')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :loading="inlineSaving" @click="liveSwitch(item) && saveInlineItem(item, item.id.concat('live'))">{{$t('save')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
                <div v-if="isEditOrderMode"><span v-if="value" class="red white--text pa-1 rounded"><b>Live</b></span></div>
                <div v-if="isEditOrderMode"><span v-if="!value" class="grey lighten-2 white--text pa-1 rounded"><b>Live</b></span></div>
            </template>
            <template v-slot:item.createdAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.updatedAt="{value}">
                {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
            </template>
            <template v-slot:item.feature="{value}">
                {{value.name}}
            </template>
            <template v-slot:item.actions="{item}">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                       @click="initEditAgendaItem(item)">
                    {{$t('edit')}}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                       @click="deleteAgendaItem(item)">
                    {{$t('delete')}}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editAgendaItemDialogShown"
                  max-width="600px"
                  persistent
                  scrollable
                  :retain-focus="false"
                  >
            <v-card>
                <v-card-title>
                    {{$t('agenda_item.title')}}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditAgendaItemFormValid">
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.order')"
                                                  :rules=[agendaOrderRule]
                                                  :placeholder="$t('agenda_item.order')"
                                                  v-model="editingAgendaItem.order"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="120"
                                        transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field outlined
                                                  :label="$t('agenda_item.start_time')"
                                                  :placeholder="$t('agenda_item.start_time')"
                                                  v-model="startTime"
                                                  v-on="on"
                                                  :rules=[timeRule]
                                                  ></v-text-field>
                                        </template>
                                        <v-time-picker format="24hr" v-model="startTimePicker"></v-time-picker>
                                    </v-menu>
                                </v-col>
                                <v-col class="py-0">
                                    <v-menu
                                        :close-on-content-click="false"
                                        :nudge-right="120"
                                        transition="scale-transition">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field outlined
                                                  :label="$t('agenda_item.end_time')"
                                                  :placeholder="$t('agenda_item.end_time')"
                                                  v-model="endTime"
                                                  v-on="on"
                                                  :rules=[timeRule]
                                                  ></v-text-field>
                                        </template>
                                        <v-time-picker format="24hr" v-model="endTimePicker"></v-time-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.date_string')"
                                                  :placeholder="$t('agenda_item.date_string')"
                                                  v-model="editingAgendaItem.date_string"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="editingAgendaItem.id">
                                <v-col class="py-0">
                                    <v-select outlined multiple
                                                  :label="$t('agenda_item.moderator')"
                                                  :placeholder="$t('agenda_item.moderator')"
                                                  :items="speakerItems"
                                                  item-value="id"
                                                  :loading="isSpeakerItemPending"
                                                  v-model="editingAgendaItem.moderator_list"
                                                  return-object>
                                        <template v-slot:selection="{ item }">
                                            {{ item.name }}, 
                                        </template>
                                        <template v-slot:item="{ item, attrs, on }">
                                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-row no-gutters align="center">
                                                            <v-badge inline :content="getModeratorOrder(item.id)" :value="getModeratorOrder(item.id)" left>
                                                                <img v-if="item && item.photo && item.photo.src" class="pa-1" :src="getFileUrl(item.photo)" width="40px" height="40px">{{ item.name + ' ' + item.lastname }} - {{ item.title }}
                                                            </v-badge>
                                                        </v-row>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                        </v-list-item>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row v-if="editingAgendaItem.id">
                                <v-col class="py-0">
                                    <v-select outlined multiple
                                            :label="$t('agenda_item.speaker')"
                                            :placeholder="$t('agenda_item.speaker')"
                                            :items="speakerItems"
                                            item-value="id"
                                            :loading="isSpeakerItemPending"
                                            v-model="editingAgendaItem.speaker_list"
                                            return-object>
                                        <template v-slot:selection="{ item }">
                                            {{ item.name }}, 
                                        </template>
                                        <template v-slot:item="{ item, attrs, on }">
                                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                <v-list-item-action>
                                                    <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-row no-gutters align="center">
                                                            <v-badge inline :content="getSpeakerOrder(item.id)" :value="getSpeakerOrder(item.id)" left>
                                                                <img v-if="item && item.photo && item.photo.src" class="pa-1" :src="getFileUrl(item.photo)" width="40px" height="40px">{{ item.name + ' ' + item.lastname }} - {{ item.title }}
                                                            </v-badge>
                                                        </v-row>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                        </v-list-item>
                                        </template>
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col class="pt-0">
                                    Moderator and Speaker can be edited later.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.agenda_item_key')"
                                                  :placeholder="$t('agenda_item.agenda_item_key')"
                                                  v-model="editingAgendaItem.agenda_item_key"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.location')"
                                                  :placeholder="$t('agenda_item.location')"
                                                  v-model="editingAgendaItem.location"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.location_tc')"
                                                  :placeholder="$t('agenda_item.location_tc')"
                                                  v-model="editingAgendaItem.location_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.location_sc')"
                                                  :placeholder="$t('agenda_item.location_sc')"
                                                  v-model="editingAgendaItem.location_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.session')"
                                                  :placeholder="$t('agenda_item.session')"
                                                  v-model="editingAgendaItem.session"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.flight')"
                                                  :placeholder="$t('agenda_item.flight')"
                                                  v-model="editingAgendaItem.flight"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.tag')"
                                                  :placeholder="$t('agenda_item.tag')"
                                                  v-model="editingAgendaItem.tag"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.tag_tc')"
                                                  :placeholder="$t('agenda_item.tag_tc')"
                                                  v-model="editingAgendaItem.tag_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.tag_sc')"
                                                  :placeholder="$t('agenda_item.tag_sc')"
                                                  v-model="editingAgendaItem.tag_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.track')"
                                                  :placeholder="$t('agenda_item.track')"
                                                  v-model="editingAgendaItem.track"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.track_tc')"
                                                  :placeholder="$t('agenda_item.track_tc')"
                                                  v-model="editingAgendaItem.track_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                                  :label="$t('agenda_item.track_sc')"
                                                  :placeholder="$t('agenda_item.track_sc')"
                                                  v-model="editingAgendaItem.track_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <!-- <v-row>
                                <v-col class="py-0">
                                    <v-file-input accept="image/*"
                                                :label="$t('agenda_item.picture')"
                                                v-model="editingAgendaItem.picture"
                                                :append-outer-icon="editingAgendaItem.picture ? 'mdi-open-in-new' : undefined"
                                                @click:append-outer="open(getFileUrl(editingAgendaItem.picture), '_blank')">
                                        <template v-slot:selection="{file}">
                                            <v-img :src="getFileUrl(file)"
                                                    max-width="250px"
                                                    max-height="250px"></v-img>
                                        </template>
                                    </v-file-input>
                                </v-col>
                            </v-row> -->
                            <v-row>
                                <v-col class="py-0 mt-n3">
                                    <v-checkbox
                                        :label="$t('agenda_item.live')"
                                        v-model="editingAgendaItem.live"
                                        ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0 red--text mt-n3">
                                    Enabling this option will turn off other ongoing live.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_desc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_desc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_content')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_content"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_desc_tc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_desc_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_content_tc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_content_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_desc_sc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_desc_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('agenda_item.html_content_sc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingAgendaItem.html_content_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{$t('cancel')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveAgendaItem"
                           :disabled="!isEditAgendaItemFormValid">{{$t('save')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <PopupAlert 
            v-model="confirmCancelItemDialogShown"
            title="Warning"
            message="Do you wish to cancel your amendments?"
            :onYes="cancelEditAgendaItem"
            :onNo="function() {confirmCancelItemDialogShown=false;}"
            ></PopupAlert>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width: 10px;
    }
</style>

<script>
    import {computed, ref, onMounted, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";
    import {cloneDeep} from "lodash";
    import Sortable from "sortablejs";
    import PopupAlert from "../../components/PopupAlert";
    import froalaConfig from "../../froala-config";

    export default {
        name: 'EventAgendaItemList',
        props: {
            agendaId: String,
            speakerId: String,
        },
        components:{PopupAlert},
        setup(props, {root}) {
            const {AgendaItem,SpeakerItem,AgendaItemModerator,AgendaItemSpeaker} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const agendaItemParams = computed(() => {
                return {
                    query: {
                        fAgendaId: props.agendaId,
                        $sort: {order: 1},
                    }
                }
            })
            const agendaItemQueryWhen = computed(() => {
                return !!props.agendaId;
            });
            const {items: agendaItems, isPending: isAgendaItemPending} = useFind({
                model: AgendaItem,
                params: agendaItemParams,
                queryWhen: agendaItemQueryWhen,
            });

            const speakerItemParams = computed(() => {
                return {
                    query: {
                        fSpeakerId: props.speakerId,
                        $sort: {order: 1},
                    }
                }
            });
            const speakerItemQueryWhen = computed(() => {
                return !!props.speakerId;
            });
            const {items: speakerItems, isPending: isSpeakerItemPending} = useFind({
                model: SpeakerItem,
                params: speakerItemParams,
                queryWhen: speakerItemQueryWhen,
            });

            watch(agendaItems,(newVal,old)=>{
                // console.log("AgendaItems:",newVal)
            })
            // Data Table
            const headers = ref([
                {text:'',value:'scroller',width:80},
                {text: root.$t('agenda_item.order'), value: 'order'},
                {text: root.$t('agenda_item.date_string'), value: 'date_string'},
                {text: root.$t('agenda_item.agenda_item_key'), value: 'agenda_item_key', width: '10%'},
                {text: root.$t('agenda_item.html_desc'), value: 'html_desc', width: '20%'},
                {text: root.$t('agenda_item.html_content'), value: 'html_content', width: '50%'},
                {text: root.$t('agenda_item.live'), value: 'live', width: '10%'},
                {text: '', value: 'actions', sortable: false},
            ]);

            const currentStart = ref(0);

            const currentPagination = function(e){
                currentStart.value = e.pageStart
            }
            // Add / Edit Agenda Item
            const editAgendaItemDialogShown = ref(false);
            const confirmCancelItemDialogShown = ref(false);
            const isEditAgendaItemFormValid = ref(false);

            const editOrderAgenda = ref([])
            const didOrderChange = ref(false);
            const isEditOrderMode = ref(false);
            const overlay = ref(false);
            const inlineSaving = ref(false);

            const editingAgendaItem = ref(new AgendaItem({fAgendaId: props.agendaId}));
            const inlineEditingAgendaItemList = ref({})
            const initAddAgendaItem = function () {
                editingAgendaItem.value = new AgendaItem({fAgendaId: props.agendaId});
                editingAgendaItem.value.order = agendaItems.value.length + 1
                editingAgendaItem.value.moderator_list = [];
                editingAgendaItem.value.speaker_list = [];
                editAgendaItemDialogShown.value = true;
            };
            const initEditAgendaItem = function (agendaItem) {
                if(!isEditOrderMode.value){
                    editingAgendaItem.value = cloneDeep(agendaItem);
                    if (editingAgendaItem.value.start_time) {
                        editingAgendaItem.value.start_time = DateTime.fromISO(editingAgendaItem.value.start_time).toFormat('HH:mm');
                    }
                    if (editingAgendaItem.value.end_time) {
                        editingAgendaItem.value.end_time = DateTime.fromISO(editingAgendaItem.value.end_time).toFormat('HH:mm');
                    }
                    editingAgendaItem.value.moderator_list = [];
                    editingAgendaItem.value.speaker_list = [];
                    editingAgendaItem.value.f_agenda_item_moderators.sort((a, b) => {
                        return a.order - b.order;
                    });
                    editingAgendaItem.value.f_agenda_item_speakers.sort((a, b) => {
                        return a.order - b.order;
                    });
                    editingAgendaItem.value.f_agenda_item_moderators.forEach((speaker) => {
                        const indexOfModerator = speakerItems.value.findIndex(x => x.id === speaker.fSpeakerPeopleId)
                        if (indexOfModerator !== -1) {
                            editingAgendaItem.value.moderator_list.push(speakerItems.value[indexOfModerator]);
                        }
                    })
                    editingAgendaItem.value.f_agenda_item_speakers.forEach((speaker) => {
                        const indexOfSpeaker = speakerItems.value.findIndex(x => x.id === speaker.fSpeakerPeopleId)
                        if (indexOfSpeaker !== -1) {
                            editingAgendaItem.value.speaker_list.push(speakerItems.value[indexOfSpeaker]);
                        }
                    })
                    editAgendaItemDialogShown.value = true;
                }
            };
            const deleteAgendaItem = function (agendaItem) {
                if(!isEditOrderMode.value){                
                    if (confirm(root.$t('agenda_item.confirm_delete'))) {
                        agendaItem.remove().then(() => {
                        }, root.$handleFeatherError.bind(root));
                    }
                }
            };
            const saveAgendaItem = async function () {
                if (editingAgendaItem.value.id !== undefined) {
                    editingAgendaItem.value.moderator_list.forEach((speaker, index) => {
                        const indexOfModerator = editingAgendaItem.value.f_agenda_item_moderators.findIndex(x => x.fSpeakerPeopleId === speaker.id)
                        if (indexOfModerator !== -1) {
                            // amend record
                            const editingSpeaker = new AgendaItemModerator({
                                id: editingAgendaItem.value.f_agenda_item_moderators[indexOfModerator].id,
                                fAgendaItemId: editingAgendaItem.value.id,
                                fSpeakerPeopleId: speaker.id,
                                order: index
                            });
                            editingSpeaker.save();
                        } else {
                            // add new record
                            const editingSpeaker = new AgendaItemModerator({
                                fAgendaItemId: editingAgendaItem.value.id,
                                fSpeakerPeopleId: speaker.id,
                                order: index
                            });
                            editingSpeaker.save();
                        }
                    });
                    editingAgendaItem.value.speaker_list.forEach((speaker, index) => {
                        const indexOfSpeaker = editingAgendaItem.value.f_agenda_item_speakers.findIndex(x => x.fSpeakerPeopleId === speaker.id)
                        if (indexOfSpeaker !== -1) {
                            // amend record
                            const editingSpeaker = new AgendaItemSpeaker({
                                id: editingAgendaItem.value.f_agenda_item_speakers[indexOfSpeaker].id,
                                fAgendaItemId: editingAgendaItem.value.id,
                                fSpeakerPeopleId: speaker.id,
                                order: index
                            });
                            editingSpeaker.save();
                        } else {
                            // add new record
                            const editingSpeaker = new AgendaItemSpeaker({
                                fAgendaItemId: editingAgendaItem.value.id,
                                fSpeakerPeopleId: speaker.id,
                                order: index
                            });
                            editingSpeaker.save();
                        }
                    });
                    editingAgendaItem.value.f_agenda_item_moderators.forEach(speaker => {
                        // remove record
                        if (!editingAgendaItem.value.moderator_list.some(x => x.id === speaker.fSpeakerPeopleId)) {
                            const editingSpeaker = new AgendaItemModerator({
                                id: speaker.id
                            });
                            editingSpeaker.remove();
                        }
                    })
                    editingAgendaItem.value.f_agenda_item_speakers.forEach(speaker => {
                        // remove record
                        if (!editingAgendaItem.value.speaker_list.some(x => x.id === speaker.fSpeakerPeopleId)) {
                            const editingSpeaker = new AgendaItemSpeaker({
                                id: speaker.id
                            });
                            editingSpeaker.remove();
                        }
                    })
                }
                delete editingAgendaItem.value.moderator_list;
                delete editingAgendaItem.value.speaker_list;
                if (editingAgendaItem.value.live) {
                    agendaItems.value.forEach((element) => {
                        if (element.id != editingAgendaItem.value.id && element.live) {
                            element.live = false;
                            element.save().then(() => {
                                AgendaItem.get(element.id);
                            }, root.$handleFeatherError.bind(root));
                        }
                    })
                }
                editingAgendaItem.value.start_time = startTime.value ? startTime.value : null;
                editingAgendaItem.value.end_time = endTime.value ? endTime.value : null;
                if (editingAgendaItem.value.picture instanceof File){
                    editingAgendaItem.value.picture = {
                        src: await root.$uploadFile(editingAgendaItem.value.picture)
                    };
                }
                if (!editingAgendaItem.value.picture) {
                    editingAgendaItem.value.picture = null;
                }
                editingAgendaItem.value.save().then(() => {
                    AgendaItem.get(editingAgendaItem.value.id);
                    editAgendaItemDialogShown.value = false;
                    root.$store.dispatch('showSnackBar', root.$t('agenda_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
            };
            const cancelEditAgendaItem = function(){
                editAgendaItemDialogShown.value = false;
                confirmCancelItemDialogShown.value = false;
            }

            watch(agendaItems,(agendaItems,old)=>{
                const newList = {}
                for(let i=0;i<agendaItems.length;i++){
                    newList[agendaItems[i].id] = cloneDeep(agendaItems[i])
                }
                inlineEditingAgendaItemList.value = newList
            })
            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };
            const openInline = function(agendaItem){
                inlineEditingAgendaItemList.value[agendaItem.id] = cloneDeep(agendaItem)
            }
            const cancelInline = function(item, ref=null){
                if (ref) {
                    this.$refs[ref].isActive = false;
                }
            }
            const saveInlineItem = async function (item, ref=null){
                inlineSaving.value = true;
                await inlineEditingAgendaItemList.value[item.id].save().then(()=>{
                    AgendaItem.get(item.id).then(()=>{
                    });
                    root.$store.dispatch('showSnackBar', root.$t('agenda_item.save_successful'));
                }, root.$handleFeatherError.bind(root));
                inlineSaving.value = false;
                if (ref) {
                    this.$refs[ref].isActive = false;
                }
            }
            const liveSwitch = async function (item) {
                if (inlineEditingAgendaItemList.value[item.id].live && !item.live) {
                    // remove all other ongoing live except this one
                    agendaItems.value.forEach((element) => {
                        if (element.id != item.id && element.live) {
                            element.live = false;
                            element.save().then(() => {
                                AgendaItem.get(element.id);
                            }, root.$handleFeatherError.bind(root));
                        }
                    })
                }
            }
            
            const initEditOrder = function() {
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderAgenda.value = cloneDeep(agendaItems.value);
            }
            const saveEditOrder = async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                for(let i=0;i<editOrderAgenda.value.length;i++){
                    await editOrderAgenda.value[i].save().then(()=>{
                        AgendaItem.get(editOrderAgenda.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false;
            }

            const tableAgendas = computed(()=>{
                return isEditOrderMode.value? editOrderAgenda.value:agendaItems.value;
            })

            onMounted(() => {
                let tables = document.querySelectorAll('.v-data-table tbody');
                Sortable.create(tables[2],
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderAgenda.value.splice(oldIndex,1)[0];
                            editOrderAgenda.value.splice(newIndex,0,rowSelected);

                            didOrderChange.value = true
                            for(let i=0;i<editOrderAgenda.value.length;i++){
                                editOrderAgenda.value[i].order = i+1
                            }
                        }
                    }
                )
            });

            const agendaOrderRule = function(value){
                const onlyNumberRule =  /^[0-9]+$/;
                return onlyNumberRule.test(value) || 'Invalid Number';
            }

            const timeRule = (value) => {
                return !value || /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value) || 'Invalid time format';
            }

            const getSpeakerOrder = (id) => {
                return editingAgendaItem.value.speaker_list.findIndex(x => x.id === id) + 1;
            }
            const getModeratorOrder = (id) => {
                return editingAgendaItem.value.moderator_list.findIndex(x => x.id === id) + 1;
            }

            const startTime = ref('');
            const endTime = ref('');
            const startTimePicker = ref('');
            const endTimePicker = ref('');

            watch(editAgendaItemDialogShown, (newVal, oldVal) => {
                if (newVal && !oldVal) {
                    startTime.value = editingAgendaItem.value.start_time;
                    endTime.value = editingAgendaItem.value.end_time;
                    startTimePicker.value = editingAgendaItem.value.start_time;
                    endTimePicker.value = editingAgendaItem.value.end_time;
                }
            })

            watch(startTime, (newVal, oldVal) => {
                // time format checking before showing NaN
                if (!editAgendaItemDialogShown.value) {
                    return;
                }
                if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(newVal)) { // valid 24hrs time format
                    startTimePicker.value = newVal;
                } else {
                    startTimePicker.value = "";
                }
            })

            watch(endTime, (newVal, oldVal) => {
                // time format checking before showing NaN
                if (!editAgendaItemDialogShown.value) {
                    return;
                }
                if (/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(newVal)) { // valid 24hrs time format
                    endTimePicker.value = newVal;
                } else {
                    endTimePicker.value = "";
                }
            })

            watch(startTimePicker, (newVal, oldVal) => {
                if (newVal) {
                    startTime.value = newVal;
                }
            })

            watch(endTimePicker, (newVal, oldVal) => {
                if (newVal) {
                    endTime.value = newVal;
                }
            })

            const open = (link, target) => {
                window.open(link, target);
            }

            return {
                froalaConfig: {
                    ...froalaConfig,
                    toolbarSticky: false,
                    zIndex: 2000
                },
                showEditor,

                agendaItems,
                tableAgendas,
                isAgendaItemPending,
                inlineEditingAgendaItemList,
                headers,

                editAgendaItemDialogShown,
                confirmCancelItemDialogShown,
                initAddAgendaItem,
                initEditAgendaItem,
                deleteAgendaItem,
                isEditAgendaItemFormValid,
                editingAgendaItem,
                saveAgendaItem,
                cancelEditAgendaItem,
                
                DateTime,
                getFileUrl: root.$getFileURL,

                previewHtmlContentOption,
                openInline,
                cancelInline,
                saveInlineItem,

                overlay,
                inlineSaving,
                isEditOrderMode,
                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                currentPagination,
                agendaOrderRule,

                speakerItems,
                isSpeakerItemPending,

                getSpeakerOrder,
                getModeratorOrder,

                liveSwitch,

                startTime,
                endTime,
                startTimePicker,
                endTimePicker,
                timeRule,

                open,
            }
        },
        mounted() {
            setTimeout(() => {
               this.showEditor = true;
            }, 100);
        }
    }
</script>
